import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cashflow-container" }
const _hoisted_2 = { class: "cashflow-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "header-actions" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "control-label" }
const _hoisted_7 = { class: "stat-icon-wrapper" }
const _hoisted_8 = { class: "stat-content" }
const _hoisted_9 = { class: "stat-value plus_color" }
const _hoisted_10 = { class: "stat-icon-wrapper" }
const _hoisted_11 = { class: "stat-content" }
const _hoisted_12 = { class: "stat-value minus_color" }
const _hoisted_13 = { class: "stat-icon-wrapper" }
const _hoisted_14 = { class: "stat-content" }
const _hoisted_15 = { class: "stat-value" }
const _hoisted_16 = {
  key: 0,
  class: "plus_color"
}
const _hoisted_17 = {
  key: 1,
  class: "minus_color"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_DxCommonSeriesSettings = _resolveComponent("DxCommonSeriesSettings")!
  const _component_DxTitle = _resolveComponent("DxTitle")!
  const _component_DxValueAxis = _resolveComponent("DxValueAxis")!
  const _component_DxSeries = _resolveComponent("DxSeries")!
  const _component_DxLegend = _resolveComponent("DxLegend")!
  const _component_DxTooltip = _resolveComponent("DxTooltip")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxChart = _resolveComponent("DxChart")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxLoadIndicator = _resolveComponent("DxLoadIndicator")!
  const _component_DxExportChart = _resolveComponent("DxExportChart")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxGrouping = _resolveComponent("DxGrouping")!
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxTotalItem = _resolveComponent("DxTotalItem")!
  const _component_DxGroupItem = _resolveComponent("DxGroupItem")!
  const _component_DxSummary = _resolveComponent("DxSummary")!
  const _component_DxZoomAndPan = _resolveComponent("DxZoomAndPan")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header-text" }, [
          _createElementVNode("h1", { class: "cashflow-title" }, "Raport Cash Flow"),
          _createElementVNode("p", { class: "cashflow-subtitle" }, "Analiză încasări, plăți și solduri bancare")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            color: "primary",
            "prepend-icon": "mdi-refresh",
            variant: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getCashFlow(_ctx.timeFrame, _ctx.days)))
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Actualizează ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            color: "primary",
            "prepend-icon": "mdi-download",
            variant: "outlined"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Export ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_v_card, {
      class: "tabs-card",
      elevation: "2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event)),
          "bg-color": "white",
          color: "primary",
          grow: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, { value: "predictie" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { start: "" }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("mdi-chart-line", -1)
                  ]))]),
                  _: 1
                }),
                _cache[7] || (_cache[7] = _createTextVNode(" Predicție încasări/plăți ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, { value: "banci" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { start: "" }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-bank", -1)
                  ]))]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" Conturi Bănci ", -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (_ctx.activeTab === 'predictie' && _ctx.loadingFacturi === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_v_card, {
            class: "control-card",
            elevation: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { align: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_v_icon, {
                              color: "primary",
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode("mdi-calendar-range", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[11] || (_cache[11] = _createTextVNode(" Pentru câte zile se afișează date în viitor? ", -1))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxNumberBox, {
                            value: _ctx.days,
                            min: 0,
                            "show-spin-buttons": true,
                            onValueChanged: _ctx.updateRange
                          }, null, 8, ["value", "onValueChanged"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, {
            class: "chart-card",
            elevation: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "card-title" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    size: "24",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("mdi-chart-bar", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "Predicție încasări/plăți", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DxChart, { "data-source": _ctx.dataSource }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxCommonSeriesSettings, {
                        "argument-field": "state",
                        type: "stackedbar"
                      }),
                      _createVNode(_component_DxValueAxis, { position: "right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxTitle, { text: "RON" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DxSeries, {
                        name: "De Incasat",
                        "value-field": "plus",
                        color: "#43A047"
                      }),
                      _createVNode(_component_DxSeries, {
                        name: "De Achitat",
                        "value-field": "minus",
                        color: "#D32F2F"
                      }),
                      _createVNode(_component_DxSeries, {
                        name: "Total",
                        "value-field": "total",
                        type: "spline",
                        color: "#6b71c3"
                      }),
                      _createVNode(_component_DxLegend, {
                        "horizontal-alignment": "center",
                        "item-text-position": "top",
                        "vertical-alignment": "bottom"
                      }),
                      _createVNode(_component_DxTooltip, {
                        enabled: true,
                        "customize-tooltip": _ctx.customizeTooltip,
                        zIndex: "5000"
                      }, null, 8, ["customize-tooltip"]),
                      _createVNode(_component_DxExport, { enabled: true })
                    ]),
                    _: 1
                  }, 8, ["data-source"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, {
            class: "timeframe-card",
            elevation: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_chip_group, {
                    modelValue: _ctx.timeFrame,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.timeFrame) = $event)),
                    "selected-class": "text-primary",
                    mandatory: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_chip, { value: "1d" }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("1D", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_chip, { value: "1w" }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("1W", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_chip, { value: "1m" }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode("1M", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_chip, { value: "6m" }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("6M", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_chip, { value: "1y" }, {
                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createTextVNode("1Y", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_chip, { value: "5y" }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("5Y", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_chip, { value: "max" }, {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode("MAX", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "stats-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "stat-card stat-card-plus",
                    elevation: "2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_v_icon, {
                          color: "#43A047",
                          size: "32"
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createTextVNode("mdi-arrow-up-bold", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "stat-label" }, "Total de încasat", -1)),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.totalDeIncasat.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " RON ", 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "stat-card stat-card-minus",
                    elevation: "2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_v_icon, {
                          color: "#D32F2F",
                          size: "32"
                        }, {
                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                            _createTextVNode("mdi-arrow-down-bold", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "stat-label" }, "Total de achitat", -1)),
                        _createElementVNode("div", _hoisted_12, _toDisplayString((-_ctx.totalDeAchitat).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " RON ", 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "stat-card stat-card-total",
                    elevation: "2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_v_icon, {
                          color: "#6b71c3",
                          size: "32"
                        }, {
                          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                            _createTextVNode("mdi-calculator", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "stat-label" }, "Total predicție", -1)),
                        _createElementVNode("div", _hoisted_15, [
                          (_ctx.total > 0.01)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.total.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " RON ", 1))
                            : (_ctx.total < -0.01)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.total.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " RON ", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_18, "0 RON"))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "partners-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "partners-card",
                    elevation: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "card-title" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            size: "24",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                              _createTextVNode("mdi-arrow-up-bold-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[28] || (_cache[28] = _createElementVNode("span", null, "Top sume de încasat după partener", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "pa-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.topNeincasat,
                            allowColumnReordering: true,
                            columns: ['Nume', 'CUI', 'Sold']
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSorting, { mode: "none" }),
                              _createVNode(_component_DxFilterRow, { visible: true })
                            ]),
                            _: 1
                          }, 8, ["data-source"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "partners-card",
                    elevation: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "card-title" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            size: "24",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                              _createTextVNode("mdi-arrow-down-bold-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Top sume de achitat după partener", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "pa-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.topNeachitat,
                            allowColumnReordering: true,
                            columns: ['Nume', 'CUI', 'Sold']
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSorting, { mode: "none" }),
                              _createVNode(_component_DxFilterRow, { visible: true })
                            ]),
                            _: 1
                          }, 8, ["data-source"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    ((_ctx.activeTab === 'predictie' && _ctx.loadingFacturi === true) || (_ctx.activeTab === 'banci' && _ctx.loadingConturiBanci === true))
      ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "text-center py-16"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxLoadIndicator, {
                  id: "large-indicator",
                  height: 60,
                  width: 60
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 'banci' && _ctx.loadingConturiBanci === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_v_row, { class: "banks-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "bank-card",
                    elevation: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "card-title" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "success",
                            size: "24",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                              _createTextVNode("mdi-plus-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[32] || (_cache[32] = _createElementVNode("span", null, "Debit", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "pa-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxDataGrid, {
                            allowColumnReordering: true,
                            "data-source": _ctx.conturiBanci.filter(cb => cb.Final >= 0),
                            allowColumnResizing: true,
                            columnAutoWidth: false,
                            columnMinWidth: 50,
                            columnResizingMode: 'nextColumn',
                            "show-borders": true,
                            syncLookupFilterValues: false,
                            onExporting: _ctx.onExporting,
                            "filter-sync-enabled": true,
                            style: {"height":"600px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxExportChart, {
                                enabled: true,
                                formats: ['pdf', 'xlsx'],
                                "allow-export-selected-data": true
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxScrolling, { mode: "virtual" }),
                              _createVNode(_component_DxGrouping, {
                                "context-menu-enabled": false,
                                autoExpandAll: false
                              }),
                              _createVNode(_component_DxGroupPanel, {
                                visible: true,
                                "allow-column-dragging": false
                              }),
                              _createVNode(_component_DxLoadPanel, {
                                enabled: true,
                                visible: _ctx.loadingConturiBanci
                              }, null, 8, ["visible"]),
                              _createVNode(_component_DxSorting, { mode: "multiple" }),
                              _createVNode(_component_DxStateStoring, {
                                enabled: true,
                                filterValue: false,
                                "storage-key": "CashFlowConturiBanci"
                              }),
                              _createVNode(_component_DxColumnChooser, {
                                enabled: true,
                                title: "Selector coloane"
                              }),
                              _createVNode(_component_DxSelection, { mode: "multiple" }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                width: 240,
                                placeholder: "Cauta ..."
                              }),
                              _createVNode(_component_DxColumn, {
                                "data-field": "BancaNume",
                                caption: "Bancă",
                                "group-index": 0
                              }),
                              _createVNode(_component_DxColumn, {
                                "data-field": "ContNumePC",
                                caption: "Cont"
                              }),
                              _createVNode(_component_DxColumn, {
                                "data-field": "ContSimbolPC",
                                caption: "Simbol cont"
                              }),
                              _createVNode(_component_DxColumn, {
                                caption: "Sold(valută)",
                                cellTemplate: _ctx.applySuffixValuta,
                                "calculate-sort-value": "Final",
                                "allow-sorting": true
                              }, null, 8, ["cellTemplate"]),
                              _createVNode(_component_DxColumn, {
                                caption: "Sold(RON)",
                                cellTemplate: _ctx.applySuffixRON,
                                "calculate-sort-value": "FinalLei",
                                "allow-sorting": true
                              }, null, 8, ["cellTemplate"]),
                              _createVNode(_component_DxSummary, { "calculate-custom-summary": _ctx.calculateSelectedRow }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxTotalItem, {
                                    name: "sumaFinalLei",
                                    "show-in-column": "Sold(RON)",
                                    "summary-type": "custom",
                                    "customize-text": _ctx.formatSummaryText
                                  }, null, 8, ["customize-text"]),
                                  _createVNode(_component_DxGroupItem, {
                                    name: "sumaFinalLei",
                                    "show-in-column": "Sold(RON)",
                                    "summary-type": "custom",
                                    "customize-text": _ctx.formatSummaryText,
                                    alignByColumn: true
                                  }, null, 8, ["customize-text"])
                                ]),
                                _: 1
                              }, 8, ["calculate-custom-summary"]),
                              _createVNode(_component_DxZoomAndPan, {
                                "argument-axis": "both",
                                "value-axis": "both"
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "onExporting"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "bank-card",
                    elevation: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "card-title" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "error",
                            size: "24",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                              _createTextVNode("mdi-minus-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[34] || (_cache[34] = _createElementVNode("span", null, "Credit", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "pa-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxDataGrid, {
                            allowColumnReordering: true,
                            "data-source": _ctx.conturiBanci.filter(cb => cb.Final < 0),
                            allowColumnResizing: true,
                            columnAutoWidth: false,
                            columnMinWidth: 50,
                            columnResizingMode: 'nextColumn',
                            "show-borders": true,
                            syncLookupFilterValues: false,
                            onExporting: _ctx.onExporting,
                            "filter-sync-enabled": true,
                            style: {"height":"600px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxExportChart, {
                                enabled: true,
                                formats: ['pdf', 'xlsx'],
                                "allow-export-selected-data": true
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxScrolling, { mode: "virtual" }),
                              _createVNode(_component_DxGrouping, {
                                "context-menu-enabled": false,
                                autoExpandAll: false
                              }),
                              _createVNode(_component_DxGroupPanel, {
                                visible: true,
                                "allow-column-dragging": false
                              }),
                              _createVNode(_component_DxLoadPanel, {
                                enabled: true,
                                visible: _ctx.loadingConturiBanci
                              }, null, 8, ["visible"]),
                              _createVNode(_component_DxSorting, { mode: "multiple" }),
                              _createVNode(_component_DxStateStoring, {
                                enabled: true,
                                filterValue: false,
                                "storage-key": "CashFlowConturiBanci"
                              }),
                              _createVNode(_component_DxColumnChooser, {
                                enabled: true,
                                title: "Selector coloane"
                              }),
                              _createVNode(_component_DxSelection, { mode: "multiple" }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                width: 240,
                                placeholder: "Cauta ..."
                              }),
                              _createVNode(_component_DxColumn, {
                                "data-field": "BancaNume",
                                caption: "Bancă",
                                "group-index": 0
                              }),
                              _createVNode(_component_DxColumn, {
                                "data-field": "ContNumePC",
                                caption: "Cont"
                              }),
                              _createVNode(_component_DxColumn, {
                                "data-field": "ContSimbolPC",
                                caption: "Simbol cont"
                              }),
                              _createVNode(_component_DxColumn, {
                                caption: "Sold(valută)",
                                cellTemplate: _ctx.applySuffixValuta,
                                "calculate-sort-value": "Final",
                                "allow-sorting": true
                              }, null, 8, ["cellTemplate"]),
                              _createVNode(_component_DxColumn, {
                                caption: "Sold(RON)",
                                cellTemplate: _ctx.applySuffixRON,
                                "calculate-sort-value": "FinalLei",
                                "allow-sorting": true
                              }, null, 8, ["cellTemplate"]),
                              _createVNode(_component_DxSummary, { "calculate-custom-summary": _ctx.calculateSelectedRow }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxTotalItem, {
                                    name: "sumaFinalLei",
                                    "show-in-column": "Sold(RON)",
                                    "summary-type": "custom",
                                    "customize-text": _ctx.formatSummaryText
                                  }, null, 8, ["customize-text"]),
                                  _createVNode(_component_DxGroupItem, {
                                    name: "sumaFinalLei",
                                    "show-in-column": "Sold(RON)",
                                    "summary-type": "custom",
                                    "customize-text": _ctx.formatSummaryText,
                                    alignByColumn: true
                                  }, null, 8, ["customize-text"])
                                ]),
                                _: 1
                              }, 8, ["calculate-custom-summary"]),
                              _createVNode(_component_DxZoomAndPan, {
                                "argument-axis": "both",
                                "value-axis": "both"
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "onExporting"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}